/** The Veo "O": the teal broken ring of the veoride.com logo (also the favicon, public/favicon.svg). */
export function VeoMark({ size = 28, color = '#00b8aa' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="-4 -5.5 108 108" aria-hidden focusable="false">
      <path
        fill={color}
        fillRule="evenodd"
        d="M54 0C82 2 100 20 100 48.5 100 80 81 97 50 97 19 97 0 80 0 48.5 0 21 17 3 43 .4L50.5 8 41.8 16.8C27 19.5 18.2 30 18.2 48.5 18.2 70 28 81.4 50 81.4 72 81.4 81.8 70 81.8 48.5 81.8 27 72 17 53.9 16.2L61.8 8Z"
      />
    </svg>
  );
}
